import { useContext } from "react";
import {
  Box,
  Stack,
  Table,
  Avatar,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Typography,
  TableContainer,
} from "@mui/material";
//Srcs
import "../../Style/pagestyle.scss";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";

import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";

import moment from "moment";
import useWithDimension from "../../Hooks/useWithDimension";
import MemberInMandateAction from "../../Components/MemberInMandate/MemberInMandateAction";

export default function MemberInMandateLossOfMembership({
  page,
  limit,
  loading,
  refetch,
  setPage,
  tableData,
  setLoading,
  handleLimit,
  paginationData,
}) {
  const { t } = useContext(AuthContext); 
  const navigate = useNavigate();
  const handleNavigate = (id) => navigate(`/member-in-mandate/member-details?id=${id}`); 
  const { width } = useWithDimension(); 
  return (
    <Box className="body-container">
      <TableContainer sx={{ maxWidth: `${width}px` }}>
        <Table className="table" aria-label="simple table">
          <TableHead className="header-row ">
            <TableRow>
              <TableCell className={t("class-name-header-title-start")} width="4%">
                {t("no")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_full_name")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_gender")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_positions")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_from_party")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_resign_date")}
              </TableCell>
              <TableCell className={t("class-name-header-title")}>
                {t("thead_reason")}
              </TableCell>
              <TableCell className={t("class-name-header-title")} align="center">
                {t("thead_number_order")}
              </TableCell>
              <TableCell className={t("class-name-header-title-end")}></TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <TableBody className="body">
              <TableRow className="body-row">
                <TableCell
                  colSpan={10}
                  className="body-cell"
                  sx={{ bgcolor: "#fff" }}
                >
                  <LoadingPage />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <>
              {tableData?.length === 0 || tableData?.length === undefined ? (
                <TableBody className="body">
                  <TableRow className="body-row">
                    <TableCell colSpan={10} className="body-cell">
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <>
                  <TableBody className="body">
                    {tableData?.map((row, index) => {
                      return (
                        <TableRow className="body-row" key={index}>
                          <TableCell className="body-cell-start" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.numbering}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            <Stack direction="row" spacing={1.4}>
                              <Stack direction="column" justifyContent="center">
                                <Avatar
                                  sx={{ width: 40, height: 40 }}
                                  alt={row?.firstNameKh}
                                  src={row?.memberId?.profile}
                                />
                              </Stack>
                              <Stack direction="column" justifyContent="center"  >
                                <Typography className="student-name">
                                  {row?.memberId?.lastNameKh + " " + row?.memberId?.firstNameKh}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.memberId?.gender === "Male" ? t("thead_male") : t("thead_female")}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.positions?.positionsNameKh}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.fromParty?.partyName}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.resignDate && moment(row?.resignDate).format("DD-MM-YYYY")}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            {row?.reason?.reason_title}
                          </TableCell>

                          <TableCell className="body-cell" onClick={() => handleNavigate(row?.memberId?._id)}>
                            <Typography sx={{
                              color: "#223D97 !important",
                              border: "1px solid #223D97",
                              fontSize: 17,
                              minHeight: 27.5,
                              textAlign: "center",
                              fontWeight: "bold",
                            }}>
                              {row?.candidateId?.numberOrder}
                            </Typography>
                          </TableCell>

                          <TableCell className="body-cell-end" align="right">
                            <MemberInMandateAction
                              editData={row}
                              setRefetch={refetch}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </>
              )}
            </>
          )}
        </Table>
      </TableContainer>

      {/* ============================ Pagination  ============================= */}
      <FooterPagination
        totalPages={paginationData?.totalPages}
        totalDocs={paginationData?.totalDocs}
        limit={limit}
        page={page}
        setPage={setPage}
        handleLimit={handleLimit}
        setLoading={setLoading}
      />
    </Box>
  );
}
